import { cn } from '../utils/styles';
import type { FlagsTabProps } from './types';
import { FlagRow } from './FlagRow';
import { FlagSkeletonRow } from './FlagSkeletonRow';
import type { ColorMode } from '../themes/theme';
import './dev-tools.css';

const THEME_OPTIONS: { value: ColorMode; label: string }[] = [
  { value: 'light', label: 'Light' },
  { value: 'liquidGlass', label: 'Liquid Glass' },
];

export function FlagsTab({
  flags,
  isLoadingFlags,
  overriddenCount,
  resetAll,
  mode,
  onThemeChange,
}: FlagsTabProps) {
  return (
    <div className="caddietw-flex caddietw-flex-col caddietw-gap-4">
      {/* Theme */}
      <div>
        <div className="devtools-section-heading caddietw-mb-2">Theme</div>
        <div className="caddietw-flex caddietw-gap-2">
          {THEME_OPTIONS.map(({ value, label }) => (
            <button
              key={value}
              type="button"
              className={cn(
                'caddietw-px-3 caddietw-py-1.5 caddietw-text-sm caddietw-rounded caddietw-border caddietw-cursor-pointer caddietw-transition-colors',
                mode === value
                  ? 'caddietw-bg-blue-600 caddietw-text-white caddietw-border-blue-600'
                  : 'caddietw-bg-white caddietw-text-gray-700 caddietw-border-gray-300 hover:caddietw-bg-gray-50'
              )}
              onClick={() => onThemeChange(value)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Feature flags */}
      <div>
        <div className="caddietw-flex caddietw-items-center caddietw-justify-between caddietw-mb-2">
          <div className="caddietw-flex caddietw-items-center caddietw-gap-2">
            <span className="devtools-section-heading">Feature Flags</span>
            {overriddenCount > 0 && (
              <span className="caddietw-text-[10px] caddietw-px-1.5 caddietw-py-0.5 caddietw-rounded-full caddietw-bg-amber-100 caddietw-text-amber-700 caddietw-font-medium">
                {overriddenCount} modified
              </span>
            )}
          </div>
          {overriddenCount > 0 && (
            <button
              type="button"
              className="caddietw-text-xs caddietw-text-red-500 caddietw-bg-transparent caddietw-border-0 caddietw-cursor-pointer hover:caddietw-text-red-700 caddietw-transition-colors caddietw-underline"
              onClick={resetAll}
            >
              Reset all
            </button>
          )}
        </div>
        <div className="caddietw-border caddietw-border-gray-200 caddietw-rounded-lg caddietw-divide-y caddietw-divide-gray-100">
          {isLoadingFlags
            ? [1, 2, 3].map((i) => <FlagSkeletonRow key={i} />)
            : flags.map((flag) => <FlagRow key={flag.key} flag={flag} />)}
        </div>
      </div>
    </div>
  );
}
